import { render, staticRenderFns } from "./BinaryNode.vue?vue&type=template&id=0a6c28a8&scoped=true&"
import script from "./BinaryNode.vue?vue&type=script&lang=js&"
export * from "./BinaryNode.vue?vue&type=script&lang=js&"
import style0 from "./BinaryNode.vue?vue&type=style&index=0&id=0a6c28a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c28a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
